var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreyArrow = function SvgGreyArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.47,
    d: "M12 20.328c4.36 0 7.969-3.617 7.969-7.969 0-4.359-3.617-7.968-7.977-7.968-4.351 0-7.96 3.609-7.96 7.968 0 4.352 3.616 7.97 7.968 7.97m.008-3.937a.587.587 0 0 1-.61-.61v-4.008l.07-1.71-.804.968-.953.961a.62.62 0 0 1-.43.18.575.575 0 0 1-.586-.586c0-.172.047-.313.157-.422l2.687-2.68c.164-.164.297-.226.469-.226.18 0 .32.07.476.226l2.68 2.68c.11.11.172.25.172.422a.58.58 0 0 1-.594.586.57.57 0 0 1-.43-.18l-.945-.96-.82-.977.07 1.718v4.008c0 .36-.25.61-.61.61"
  })));
};
export default SvgGreyArrow;